import { Capacitor } from '@capacitor/core'
import * as Sentry from '@sentry/solid'
import OneSignal from 'onesignal-cordova-plugin'

function mobile(userId?: string, email?: string) {
	try {
		if (!Capacitor.isNativePlatform()) return

		// Initialize OneSignal if needed (usually done elsewhere in your app)
		// OneSignal.setAppId('YOUR_ONESIGNAL_APP_ID') // if not already set

		if (userId) {
			OneSignal.login(userId)
			console.log('✅ OneSignal external user ID set:')
		}

		Sentry.setUser({
			id: userId,
			email: email,
		})
	} catch (err) {
		console.error('❌ initMobile error:', err)
	}
}

async function web(userId?: string, email?: string) {
	if (userId) {
		const OneSignal = (window as any).OneSignal
		if (OneSignal && typeof OneSignal.login === 'function') {
			await OneSignal.login(userId)
			console.info(`login to notificiation service: ${userId}`)
		}

		if (email) {
			Sentry.setUser({
				id: userId,
				email: email,
			})
		}
	}
}

export async function loginUserThirdParty(userId?: string, email?: string) {
	try {
		if (Capacitor.isNativePlatform()) {
			await mobile(userId, email)
		} else {
			await web(userId, email)
		}
	} catch (err) {
		console.error('❌ initApp error:', err)
	}
}
